import { create } from "zustand";
import { MaintenanceWorkflowAllowedEstablishmentData } from "../../../types/maintenanceWorkflowAllowedEstablishment.type";

interface UseCreateForwardingsFormStore {
  initForm: () => void;

  currentStep: number;
  setCurrentStep: (step: number) => void;
  increaseStep: () => void;
  decreaseStep: () => void;

  selectedEstablishments: MaintenanceWorkflowAllowedEstablishmentData[];
  setSelectedEstablishments: (establishments: MaintenanceWorkflowAllowedEstablishmentData[]) => void;
  appendSelectedEstablishment: (establishment: MaintenanceWorkflowAllowedEstablishmentData) => void;
  removeSelectedEstablishment: (establishmentId: string) => void;
}

export const useCreateForwardingsFormStore = create<UseCreateForwardingsFormStore>((set, get) => ({
  initForm: () => set({
    currentStep: 0,
    selectedEstablishments: [],
  }),

  currentStep: 0,
  setCurrentStep: (step) => set({
    currentStep: step,
  }),
  increaseStep: () => set({
    currentStep: get().currentStep + 1,
  }),
  decreaseStep: () => set({
    currentStep: get().currentStep - 1,
  }),

  selectedEstablishments: [],
  setSelectedEstablishments: (establishments) => set({
    selectedEstablishments: establishments,
  }),
  appendSelectedEstablishment: (establishment) => set({
    selectedEstablishments: [
      ...get().selectedEstablishments,
      establishment,
    ],
  }),
  removeSelectedEstablishment: (establishmentId) => set({
    selectedEstablishments: [...get().selectedEstablishments].filter((e) => e.id !== establishmentId),
  }),
}));
